
// Accordion
document.addEventListener("DOMContentLoaded", () => {

  const lenis = new Lenis({
    smooth: true,
    lerp: 0.04,          
    wheelMultiplier: 1,
    touchMultiplier: 1.2,
    smoothTouch: false
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);


  
  const items = document.querySelectorAll(".accordion-item");

  items.forEach((item, index) => {
    const header = item.querySelector(".accordion-header");
    const body = item.querySelector(".accordion-body");

    // 👉 OPEN FIRST ACCORDION ON LOAD
    if (index === 0) {
      item.classList.add("active");
      body.style.height = body.scrollHeight + "px";
    }

    header.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      // Close all
      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".accordion-body").style.height = "0px";
      });

      // Open clicked
      if (!isOpen) {
        item.classList.add("active");
        body.style.height = body.scrollHeight + "px";
      }
    });
  });
});

// Form
// document.addEventListener("DOMContentLoaded", () => {
//   const formItems = document.querySelectorAll(".form-item");

//   function checkFilled(item) {
//     const input = item.querySelector("input, textarea");
//     if (input && input.value.trim() !== "") {
//       item.classList.add("filled");
//     } else {
//       item.classList.remove("filled");
//     }
//   }

//   formItems.forEach((item) => {
//     const input = item.querySelector("input, textarea");

//     // Check on page load
//     checkFilled(item);

//     // Listen to changes
//     if (input) {
//       input.addEventListener("input", () => checkFilled(item));
//       input.addEventListener("blur", () => checkFilled(item));
//     }
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   /* =========================
//      TEXT / TEXTAREA FIELDS
//   ========================== */
//   const formItems = document.querySelectorAll(".form-item");

//   function checkFilled(item) {
//     const input = item.querySelector("input, textarea");
//     if (input && input.value.trim() !== "") {
//       item.classList.add("filled");
//     } else {
//       item.classList.remove("filled");
//     }
//   }

//   formItems.forEach((item) => {
//     const input = item.querySelector("input, textarea");

//     // Check on page load
//     checkFilled(item);

//     // Listen to changes
//     if (input) {
//       input.addEventListener("input", () => checkFilled(item));
//       input.addEventListener("blur", () => checkFilled(item));
//     }
//   });

//   /* =========================
//      COUNTRY SELECT FIELD
//   ========================== */
//   const countrySelect = document.querySelector("#country");

//   if (countrySelect) {
//     const wrapper = countrySelect.closest(".form-group-full");
//     const label = wrapper.querySelector(".country-label");

//     // Initial check (important for reload / validation)
//     if (countrySelect.value) {
//       label.textContent = countrySelect.value;
//       wrapper.classList.add("selected");
//     }

//     countrySelect.addEventListener("change", () => {
//       if (countrySelect.value) {
//         label.textContent = countrySelect.value;
//         wrapper.classList.add("selected");
//       } else {
//         label.textContent = "Country";
//         wrapper.classList.remove("selected");
//       }
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", () => {
  /* Inputs & textarea (unchanged) */
  const formItems = document.querySelectorAll(".form-item");

  function checkFilled(item) {
    const input = item.querySelector("input, textarea");
    if (input && input.value.trim() !== "") {
      item.classList.add("filled");
    } else {
      item.classList.remove("filled");
    }
  }

  formItems.forEach((item) => {
    const input = item.querySelector("input, textarea");
    if (!input) return;

    checkFilled(item);
    input.addEventListener("input", () => checkFilled(item));
    input.addEventListener("blur", () => checkFilled(item));
  });

  /* Country select */
  const countrySelect = document.querySelector("#country");

  if (countrySelect) {
    const wrapper = countrySelect.closest(".form-group-full");
    const label = wrapper.querySelector(".country-label");

    // ALWAYS start with placeholder
    label.textContent = "Country";
    wrapper.classList.remove("selected");

    countrySelect.addEventListener("change", () => {
      if (countrySelect.value) {
        label.textContent = countrySelect.value;
        wrapper.classList.add("selected");
      } else {
        label.textContent = "Country";
        wrapper.classList.remove("selected");
      }
    });
  }
});

// rotating card
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined") return;

  const cards = gsap.utils.toArray(".partner-card-wrapper .card-item");

  // Initial tightly stacked state in bottom-right corner
  const xPositions = [900, 600, 300, 850, 800];

  gsap.set(cards, {
    x: (i) => xPositions[i] || 800,
    y: 0,
    rotation: 40,
    scale: 0.95,
    opacity: 1,
    zIndex: (i) => cards.length - i
  });


  // Animation: peel from top card (most rotated) first, slide left + unrotate
  gsap.to(cards.reverse(), {
    x: 0,
    y: 0,
    rotation: 0,
    scale: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".partner-card-wrapper",
      start: "top =95%",
      end: "bottom center+=10",
      scrub: 1.5,
      // markers: true
    }
  });
});

// Tag Animation
document.addEventListener("DOMContentLoaded", () => {
  const animatedElements = document.querySelectorAll(".animate-up");

  function animateOnScroll() {
    const triggerPoint = window.innerHeight * 0.85;
    console.log(triggerPoint, "triggerPoint")

    animatedElements.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.top < triggerPoint && !el.classList.contains("active")) {
        el.classList.add("active");
      }
    });
  }

  window.addEventListener("scroll", animateOnScroll);
  animateOnScroll(); // trigger on page load
});

// Homepage Video Pop up

document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const banner = document.querySelector(".banner-section");
  const modal = document.getElementById("videoModal");
  const video = document.getElementById("popupVideo");
  const closeBtn = document.getElementById("videoClose");
  const videoWrapper = document.querySelector(".video-wrapper");

  if (!banner || !modal || !video || !videoWrapper) return;

  /* ===============================
     RESET ON LOAD
  =============================== */
  modal.classList.remove("active");
  document.body.classList.remove("video-open");
  document.body.style.top = "";
  video.pause();
  video.currentTime = 0;
  video.muted = true;
  videoWrapper.classList.remove("is-playing");

  let popupShown = false;
  let hasScrolled = false;
  let scrollY = 0;

  /* ===============================
     OPEN POPUP
  =============================== */
  function openVideoPopup() {
    scrollY = window.scrollY;

    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add("video-open");

    modal.classList.remove("active");
    void modal.offsetWidth;
    modal.classList.add("active");

    video.muted = true;
    video.play().catch(() => {});
  }

  /* ===============================
     CLOSE POPUP
  =============================== */
  function closeVideoPopup() {
    modal.classList.remove("active");
    document.body.classList.remove("video-open");
    document.body.style.top = "";
    window.scrollTo(0, scrollY);

    video.pause();
    video.currentTime = 0;
    progressFill.style.width = "0%";
    videoWrapper.classList.remove("is-playing");
  }

  closeBtn?.addEventListener("click", closeVideoPopup);
  modal.querySelector(".video-overlay")?.addEventListener("click", closeVideoPopup);

  /* ===============================
     SCROLL TRIGGER
  =============================== */
  window.addEventListener("scroll", () => (hasScrolled = true), { once: true });

  ScrollTrigger.create({
    trigger: banner,
    start: "bottom 40%",
    onEnter(self) {
      if (!hasScrolled || popupShown || self.direction !== 1) return;
      popupShown = true;
      openVideoPopup();
    }
  });

  /* ===============================
     CONTROLS
  =============================== */
  const progressBar = modal.querySelector(".video-progress");
  const progressFill = modal.querySelector(".video-progress-filled");
  const playToggle = modal.querySelector(".play-toggle");
  const muteToggle = modal.querySelector(".mute-toggle");
  const pipToggle = modal.querySelector(".pip-toggle");
  const fullscreenToggle = modal.querySelector(".fullscreen-toggle");
  const currentTimeEl = modal.querySelector(".current-time");
  const durationEl = modal.querySelector(".duration");

  if (!progressBar || !progressFill || !playToggle || !muteToggle) return;

  /* ===============================
     TIME FORMAT
  =============================== */
  const formatTime = (t) => {
    const m = Math.floor(t / 60);
    const s = Math.floor(t % 60);
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  video.addEventListener("loadedmetadata", () => {
    if (durationEl) durationEl.textContent = formatTime(video.duration);
  });

  /* ===============================
     PROGRESS (ONLY PLAYED)
  =============================== */
  video.addEventListener("timeupdate", () => {
    if (!video.duration) return;

    const percent = (video.currentTime / video.duration) * 100;
    progressFill.style.width = percent + "%";

    if (currentTimeEl) {
      currentTimeEl.textContent = formatTime(video.currentTime);
    }
  });

  /* ===============================
     SEEK
  =============================== */
  progressBar.addEventListener("click", (e) => {
    const rect = progressBar.getBoundingClientRect();
    const percent = Math.min(
      Math.max((e.clientX - rect.left) / rect.width, 0),
      1
    );
    video.currentTime = percent * video.duration;
  });

  /* ===============================
     PLAY / PAUSE
  =============================== */
  playToggle.addEventListener("click", () => {
    video.paused ? video.play().catch(() => {}) : video.pause();
  });

  video.addEventListener("play", () => {
    videoWrapper.classList.add("is-playing");
  });

  video.addEventListener("pause", () => {
    videoWrapper.classList.remove("is-playing");
  });

  /* ===============================
     MUTE / UNMUTE
  =============================== */
  const syncMuteIcon = () =>
    muteToggle.classList.toggle("is-muted", video.muted);

  muteToggle.addEventListener("click", () => {
    video.muted = !video.muted;
    syncMuteIcon();
  });

  video.addEventListener("volumechange", syncMuteIcon);

  /* ===============================
     PiP
  =============================== */
  pipToggle?.addEventListener("click", async () => {
    try {
      document.pictureInPictureElement
        ? await document.exitPictureInPicture()
        : await video.requestPictureInPicture();
    } catch {}
  });

  /* ===============================
     FULLSCREEN (NO GLITCH)
  =============================== */
  fullscreenToggle?.addEventListener("click", () => {
    document.fullscreenElement
      ? document.exitFullscreen()
      : video.requestFullscreen().catch(() => {});
  });

  /* ===============================
     END RESET
  =============================== */
  video.addEventListener("ended", () => {
    video.currentTime = 0;
    progressFill.style.width = "0%";
    videoWrapper.classList.remove("is-playing");
  });
});

// Heading Animation
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".fx-heading, .wp-block-heading").forEach(heading => {

//     const text = heading.innerText;
//     heading.innerHTML = "";

//     const words = text.split(" ");
//     const tempSpan = document.createElement("span");
//     tempSpan.style.visibility = "hidden";
//     tempSpan.style.position = "absolute";
//     tempSpan.style.whiteSpace = "nowrap";
//     heading.appendChild(tempSpan);

//     let lines = [];
//     let currentLine = "";

//     words.forEach(word => {
//       tempSpan.innerText = currentLine + word + " ";
//       if (tempSpan.offsetWidth > heading.offsetWidth) {
//         lines.push(currentLine.trim());
//         currentLine = word + " ";
//       } else {
//         currentLine += word + " ";
//       }
//     });
//     lines.push(currentLine.trim());
//     tempSpan.remove();

//     // Build final DOM
//     lines.forEach((lineText, index) => {
//       const line = document.createElement("span");
//       line.className = "fx-line";

//       const inner = document.createElement("span");
//       inner.className = "fx-line__inner";
//       inner.textContent = lineText;

//       inner.style.animationDelay = `${index * 0.2}s`;

//       line.appendChild(inner);
//       heading.appendChild(line);
//     });

//     // Intersection Observer trigger
//     const observer = new IntersectionObserver(entries => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           heading.classList.add("animate");
//           observer.unobserve(entry.target);
//         }
//       });
//     }, { threshold: 0.4 });

//     observer.observe(heading);
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  document.fonts.ready.then(() => {
    initHeadingAnimation();
  });
});

function initHeadingAnimation() {
  document.querySelectorAll(".fx-heading, .wp-block-heading").forEach(heading => {

    const text = heading.innerText;
    heading.innerHTML = "";

    const words = text.split(" ");
    const tempSpan = document.createElement("span");
    tempSpan.style.visibility = "hidden";
    tempSpan.style.position = "absolute";
    tempSpan.style.whiteSpace = "nowrap";
    heading.appendChild(tempSpan);

    let lines = [];
    let currentLine = "";

    words.forEach(word => {
      tempSpan.innerText = currentLine + word + " ";
      if (tempSpan.offsetWidth > heading.offsetWidth) {
        lines.push(currentLine.trim());
        currentLine = word + " ";
      } else {
        currentLine += word + " ";
      }
    });

    lines.push(currentLine.trim());
    tempSpan.remove();

    lines.forEach((lineText, index) => {
      const line = document.createElement("span");
      line.className = "fx-line";

      const inner = document.createElement("span");
      inner.className = "fx-line__inner";
      inner.textContent = lineText;

      inner.style.animationDelay = `${index * 0.2}s`;

      line.appendChild(inner);
      heading.appendChild(line);
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          heading.classList.add("animate");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    observer.observe(heading);
  });
}

// Description Animation
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".fade-slide, .single-body p, .wp-block-list li");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // Optional: animate only once
        }
      });
    },
    { threshold: 0.1 }
  );

  elements.forEach(el => observer.observe(el));
});

// Card
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const wrapper = document.querySelector(".card-wrapper");
  if (!wrapper) return;

  const mm = gsap.matchMedia();

  /* ================= MOBILE STACK ================= */
 mm.add("(max-width: 768px)", () => {
  const cards = gsap.utils.toArray(".card-item");
  const stackOffset = 132;

  // ← Add individual starting positions here
  gsap.set(cards, {
    opacity: 0,
    y: (i) => 120 + (i * 15) + gsap.utils.random(-40, 40, 5),   // vertical variation
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: wrapper,
      start: "top 85%",
      end: () => `+=${cards.length * 160}`,
      scrub: 2,
      invalidateOnRefresh: true,
      // markers: true,
    }
  });

  // First card comes to center
  tl.to(cards[0], {
    opacity: 1,
  
    y: 0,
    rotation: 0,
    duration: 1.2,
    ease: "power2.out"
  });

  // Rest of the stack
  cards.slice(1).forEach((card, i) => {
    const isLastTwo = i >= cards.length - 3;

    tl.to(card, {
      opacity: 1,
 
      y: -(i + 1) * stackOffset,
      rotation: 0,
      duration: 1.2,
      ease: "power2.out"
    }, isLastTwo ? "+=0.03" : "+=0.35");
  });
});

// mm.add("(min-width: 769px)", () => {
//   const row1Cards = wrapper.querySelectorAll(".row-1 .card-item");
//   const row2Cards = wrapper.querySelectorAll(".row-2 .card-item");
//   const row1Descriptions = wrapper.querySelectorAll(".row-1 .description-color");


//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: wrapper,
//       start: "top 75%",
//       end: "+=130%",   
//       scrub: 1.25 ,
//       // markers:true,    
//     }
//   });

//     tl.from(row1Cards, {
//       opacity: 0,
//       y: 50,
//       stagger: 0.09,   
//       duration: 0.32,   
//       ease: "power3.out"
//     });

//     tl.from(
//       row2Cards,
//       {
//         onStart: () => {
//           gsap.to(row1Descriptions, {
//             opacity: 0,
//             duration: 0.5,
//             stagger: 0.30,
//             ease: "power2.out"
//           });
//         },
//         onReverseComplete: () => {
//           gsap.to(row1Descriptions, {
//             opacity: 1,
//             duration: 0.5,
//             stagger: 0.05,
//             ease: "power2.out"
//           });
//         },
//         opacity: 0,
//         y: 60,
//         stagger: 0.24,  // slightly smoother flow
//         duration: 0.7,  // ⬅️ gentle slowdown
//         ease: "power3.out"
//       },
//       "+=0.18"
//     );
// });
  
mm.add("(min-width: 769px)", () => {
  const row1Cards = wrapper.querySelectorAll(".row-1 .card-item");
  const row2Cards = wrapper.querySelectorAll(".row-2 .card-item");
  const row1Descriptions = wrapper.querySelectorAll(".row-1 .description-color");

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: wrapper,
      start: "top 75%",
      end: "+=130%",
      scrub: 1.25,
      // markers: true,
    }
  });

  tl.from(row1Cards, {
    opacity: 0,
    y: 50,
    stagger: 0.09,
    duration: 0.32,
    ease: "power3.out"
  });

  tl.from(
    row2Cards,
    {
      onStart: () => {
        gsap.to(row1Descriptions, {
          opacity: 0,
          duration: 0.5,
          stagger: 0.30,
          ease: "power2.out"
        });
      },
      onReverseComplete: () => {
        gsap.to(row1Descriptions, {
          opacity: 1,
          duration: 0.5,
          stagger: 0.05,
          ease: "power2.out"
        });
      },
      opacity: 0,
      y: 60,
      stagger: 0.45,  
      duration: 1.1,   
      ease: "power3.out"
    },
    "+=1"          
  );
});
});

// Cards
document.addEventListener("DOMContentLoaded", () => {

  /* ============================
     GLOBAL: Reveal animation
     ============================ */
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".solution-card-wrapper.stack-card").forEach((card, index) => {
      const baseStart = 60;      
      const offsetPerCard = 6;   
      const startPoint = baseStart - index * offsetPerCard;

      const baseDelay = 0.08;       // base delay (seconds)
      const delayStep = 0.06;       // extra delay per card
      const delay = baseDelay + index * delayStep;

      ScrollTrigger.create({
        trigger: card,
        start: `top ${startPoint}%`,
        end: "bottom 25%",
        onEnter: () => {
          gsap.delayedCall(delay, () => {
            if (ScrollTrigger.isInViewport(card)) {
              card.classList.add("is-visible");
            }
          });
        },
        onLeaveBack: () => {
          gsap.killTweensOf(card);
          card.classList.remove("is-visible");
        },
        // markers: true
      });
    });
  }


  const allCards = document.querySelectorAll(".stack-card");

  function revealCards() {
    const triggerPoint = window.innerHeight * 0.75;

    allCards.forEach(card => {
      const rect = card.getBoundingClientRect();

      if (rect.top < triggerPoint) {
        card.classList.add("is-visible");
      } else {
        card.classList.remove("is-visible");
      }
    });
  }

  /* ============================
     COMMUNICATION ONLY: Blur
     ============================ */
  const communicationSection = document.querySelector(".communication");

  let communicationCards = [];
  if (communicationSection) {
    communicationCards = communicationSection.querySelectorAll(".stack-card");
  }

  function handleCommunicationBlur() {
    if (!communicationCards.length) return;

    // reset blur first
    communicationCards.forEach(card => {
      card.classList.remove("is-blurred");
    });

    for (let i = 0; i < communicationCards.length - 1; i++) {
      const current = communicationCards[i];
      const next = communicationCards[i + 1];

      // both cards must be visible
      if (
        !current.classList.contains("is-visible") ||
        !next.classList.contains("is-visible")
      ) {
        continue;
      }

      const currentRect = current.getBoundingClientRect();
      const nextRect = next.getBoundingClientRect();

      const overlap = currentRect.bottom - nextRect.top;

      // apply blur only when real overlap happens
      if (overlap > 40) {
        current.classList.add("is-blurred");
      }
    }
  }

  /* ============================
     Scroll / Resize handler
     ============================ */
  function onScroll() {
    revealCards();
    handleCommunicationBlur();
  }

  onScroll();
  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", onScroll);
});


// Banner Image
document.addEventListener("DOMContentLoaded", () => {
  const banner = document.querySelector(".banner-right");
  if (!banner) return;

  function handleScroll() {
    const rect = banner.getBoundingClientRect();
    const triggerPoint = window.innerHeight * 0.8;

    if (rect.top < triggerPoint) {
      banner.classList.add("is-visible");
    }
  }

  handleScroll(); // initial check
  window.addEventListener("scroll", handleScroll);
});

// Button Animation
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".primary-btn, .ternary-btn");
  if (!buttons.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target); // animate once per button
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -20% 0px" // smooth early trigger
    }
  );

  buttons.forEach(button => observer.observe(button));
});

// Header Dropdown
// document.addEventListener("DOMContentLoaded", () => {
//   const menuItems = document.querySelectorAll(".has-submenu");
//   const submenuItems = document.querySelectorAll(".submenu-item");
//   const header = document.querySelector(".site-header");
//   let closeTimeout;

//   // IMPORTANT: arrow center position inside submenu SVG
//   const ARROW_OFFSET_X = 110; // px — adjust if SVG changes

//   function closeAllSubmenus() {
//     menuItems.forEach(el => el.classList.remove("open"));
//     submenuItems.forEach(sub => {
//       sub.classList.remove("open");
//       setTimeout(() => {
//         if (!sub.classList.contains("open")) {
//           sub.style.visibility = "hidden";
//         }
//       }, 350);
//     });
//   }

//   menuItems.forEach(item => {
//     const target = item.getAttribute("data-menu");

//     item.addEventListener("mouseenter", () => {
//       clearTimeout(closeTimeout);
//       closeAllSubmenus();
//       item.classList.add("open");

//       const submenu = document.querySelector(
//         `.submenu-item[data-menu="${target}"]`
//       );

//       if (submenu) {
//         submenu.style.visibility = "visible";
//         submenu.classList.add("open");

//         const rect = item.getBoundingClientRect();
//         const headerRect = header.getBoundingClientRect();

//         // 🔥 ALIGN ARROW WITH MENU ITEM CENTER
//         const menuCenterX = rect.left + rect.width / 2;
//         submenu.style.left = `${menuCenterX - ARROW_OFFSET_X}px`;
//         submenu.style.top = `${headerRect.bottom + 12}px`;
//       }
//     });

//     item.addEventListener("mouseleave", () => {
//       const targetSubmenu = document.querySelector(
//         `.submenu-item[data-menu="${target}"]`
//       );

//       closeTimeout = setTimeout(() => {
//         if (!targetSubmenu.matches(":hover")) {
//           closeAllSubmenus();
//         }
//       }, 200);
//     });
//   });

//   submenuItems.forEach(sub => {
//     sub.addEventListener("mouseenter", () => {
//       clearTimeout(closeTimeout);
//       sub.style.visibility = "visible";
//       sub.classList.add("open");
//     });

//     sub.addEventListener("mouseleave", () => {
//       closeTimeout = setTimeout(closeAllSubmenus, 200);
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll(".has-submenu");
  const submenuItems = document.querySelectorAll(".submenu-item");
  const header = document.querySelector(".site-header");
  let closeTimeout;

  // IMPORTANT: arrow center position inside submenu SVG
  const ARROW_OFFSET_X = 34; // px — adjust if SVG changes

  // Toggle between "px" or "vw/vh"
  const USE_PERCENTAGE = false; // set true to use vw/vh units

  function closeAllSubmenus() {
    menuItems.forEach(el => el.classList.remove("open"));
    submenuItems.forEach(sub => {
      sub.classList.remove("open");
      setTimeout(() => {
        if (!sub.classList.contains("open")) {
          sub.style.visibility = "hidden";
        }
      }, 350);
    });
  }

  // function positionSubmenu(submenu, item) {
  //   const rect = item.getBoundingClientRect();
  //   const headerRect = header.getBoundingClientRect();

  //   const menuCenterX = rect.left + rect.width / 2;
  //   const leftPx = menuCenterX - ARROW_OFFSET_X;
  //   const topPx = headerRect.bottom + 12;

  //   if (USE_PERCENTAGE) {
  //     // Convert to vw/vh units
  //     const leftVw = (leftPx / window.innerWidth) * 100;
  //     const topVh = (topPx / window.innerHeight) * 100;

  //     submenu.style.left = `${leftVw.toFixed(2)}vw`;
  //     submenu.style.top = `${topVh.toFixed(2)}vh`;
  //   } else {
  //     // Default: reliable px positioning
  //     submenu.style.left = `${leftPx}px`;
  //     submenu.style.top = `${topPx}px`;
  //   }
  // }
function positionSubmenu(submenu, item) {
  const rect = item.getBoundingClientRect();
  const headerRect = header.getBoundingClientRect();

  const menuCenterX = rect.left + rect.width / 2;
  let leftPx = menuCenterX - ARROW_OFFSET_X;
  const topPx = headerRect.bottom - 20;
  console.log('topPx: ', topPx);

  // Clamp to viewport edges
  const submenuWidth = submenu.offsetWidth;
  const maxLeft = window.innerWidth - submenuWidth - 16;
  leftPx = Math.min(Math.max(leftPx, 16), maxLeft);

  submenu.style.left = `${leftPx}px`;
  submenu.style.top  = `${topPx}px`;
}
  
  menuItems.forEach(item => {
    const target = item.getAttribute("data-menu");

    item.addEventListener("mouseenter", () => {
      clearTimeout(closeTimeout);
      closeAllSubmenus();
      item.classList.add("open");

      const submenu = document.querySelector(
        `.submenu-item[data-menu="${target}"]`
      );

      if (submenu) {
        submenu.style.visibility = "visible";
        submenu.classList.add("open");
        positionSubmenu(submenu, item);
      }
    });

    item.addEventListener("mouseleave", () => {
      const targetSubmenu = document.querySelector(
        `.submenu-item[data-menu="${target}"]`
      );

      closeTimeout = setTimeout(() => {
        if (targetSubmenu && !targetSubmenu.matches(":hover")) {
          closeAllSubmenus();
        }
      }, 200);
    });
  });

  submenuItems.forEach(sub => {
    sub.addEventListener("mouseenter", () => {
      clearTimeout(closeTimeout);
      sub.style.visibility = "visible";
      sub.classList.add("open");
    });

    sub.addEventListener("mouseleave", () => {
      closeTimeout = setTimeout(closeAllSubmenus, 200);
    });
  });

  // Optional: reposition open submenus on window resize
  window.addEventListener("resize", () => {
    menuItems.forEach(item => {
      if (item.classList.contains("open")) {
        const target = item.getAttribute("data-menu");
        const submenu = document.querySelector(
          `.submenu-item[data-menu="${target}"]`
        );
        if (submenu && submenu.classList.contains("open")) {
          positionSubmenu(submenu, item);
        }
      }
    });
  });
});


// Homepage Auto Scroll
document.addEventListener('DOMContentLoaded', function () {
  // Function to initialize a Splide slider
  function initSlider(selector, options) {
    const slider = document.querySelector(selector);
    if (slider) {
      new Splide(slider, {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        arrows: false,
        pagination: false,
        ...options,
      }).mount(window.splide.Extensions);
    }
  }

  // Homepage slider (no mobile override)
  initSlider('.hp-slider .splide', {
    perPage: 1,
    autoScroll: { speed: 0.8 },
  });

  // Company slider (mobile: show 4)
  initSlider('.company-slider .splide', {
    perPage: 7,
    autoScroll: { speed: 0.8 },

    breakpoints: {
      768: {
        perPage: 3, // mobile value
      }
    }
  });
});
// Box Hovering
document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".wrapper");
  if (!wrapper) return;

  const boxes = wrapper.querySelectorAll(".box");

  boxes.forEach((box) => {
    box.addEventListener("mouseenter", () => {
      boxes.forEach(b => b.classList.remove("open"));
      box.classList.add("open");
    });
  });

  // When mouse leaves the wrapper, reopen the first box
  wrapper.addEventListener("mouseleave", () => {
    boxes.forEach(b => b.classList.remove("open"));
    boxes[0].classList.add("open");
  });
});


// Footer
function toggleFooterAccordion(header) {
  // Disable on desktop
  if (window.innerWidth > 768) return;

  const col = header.parentElement;
  const isActive = col.classList.contains('active');

  document.querySelectorAll('.footer-col').forEach(item => {
    item.classList.remove('active');
  });

  if (!isActive) {
    col.classList.add('active');
  }
}

function appendMobileFooterItems() {
  // Placeholder function to prevent ReferenceError
}

// Open the very first section (Solutions) by default on mobile
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const firstHeader = document.querySelector('.mobile-accordion-header');
    if (firstHeader) {
      toggleFooterAccordion(firstHeader);
    }
    appendMobileFooterItems();
  }
});

// Handle mobile resize
window.addEventListener('resize', function () {
  if (window.innerWidth <= 768) {
    appendMobileFooterItems();

    const anyOpen = document.querySelector('.footer-col.active');
    if (!anyOpen) {
      const firstHeader = document.querySelector('.mobile-accordion-header');
      if (firstHeader) toggleFooterAccordion(firstHeader);
    }
  }
});


// Company slider
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  const wrapper = document.querySelector(".about-slider-wrapper");
  const visionTitle = document.querySelector('.slider-title.vision');
  const missionTitle = document.querySelector('.slider-title.mission');
  const lineFill = document.querySelector('.slider-line-fill');
  const texts = gsap.utils.toArray('.slider-text');
  const titlesContainer = document.querySelector('.titles-container');

  // ✅ SAFETY GUARD: prevent GSAP from animating null elements
  if (
    !wrapper ||
    !visionTitle ||
    !missionTitle ||
    !lineFill ||
    !titlesContainer ||
    !texts.length
  ) {
    return;
  }

  const containerWidth = titlesContainer?.offsetWidth || 0;
  let currentIndex = 0;

  // Timeline driving the animations
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger:".pagemainWrapper",       
      start: "top+=200 top",
      end: "top+=400 top",          
      pin: true,                  
      pinSpacing: false,

      scrub: true,
      // markers: true
    }
  });

  // Line progress animation
  tl.to(lineFill, { scaleX: 1, ease: "none" }, 0);

  // Title movement & text swap
  tl.to([visionTitle, missionTitle], {
    x: -containerWidth * 0.4,
    ease: "none",
    onUpdate: function() {
      const progress = this.progress();
      const showMission = progress >= 0.5;

      // Set titles opacity & color
      gsap.set(visionTitle, {
        opacity: showMission ? 0.1 : 1,
        color: showMission ? "#fff" : "#ff5c39"
      });

      gsap.set(missionTitle, {
        opacity: showMission ? 1 : 0.1,
        color: showMission ? "#ff5c39" : "#fff"
      });

      // Swap text based on progress
      const newIndex = showMission ? 1 : 0;
      if (newIndex !== currentIndex) {
        texts.forEach((t, i) => t.classList.toggle("active", i === newIndex));
        currentIndex = newIndex;
      }
    }
  }, 0);
});


// Partners Tab
// document.addEventListener("DOMContentLoaded", function () {
//   const tabs = document.querySelectorAll(".tab");
//   const panels = document.querySelectorAll(".tab-panel");
//   const anchor = document.getElementById("partners-tabs-anchor");

//   if (!tabs.length || !panels.length) return;

//   function activateTabByTarget(target) {
//     tabs.forEach(tab => tab.classList.remove("active"));
//     panels.forEach(panel => panel.classList.remove("active"));

//     const activeTab = document.querySelector(`.tab[data-target="${target}"]`);
//     const activePanel = document.getElementById(target);

//     if (activeTab && activePanel) {
//       activeTab.classList.add("active");
//       activePanel.classList.add("active");
//     }
//   }

//   function scrollToTabs() {
//     if (
//       !anchor ||
//       typeof gsap === "undefined" ||
//       !gsap.plugins ||
//       !gsap.plugins.scrollTo
//     ) {
//       return;
//     }

//     gsap.to(window, {
//       duration: 1,
//       scrollTo: { y: anchor, offsetY: 20 }, // adjust offsetY if you have sticky header
//       ease: "power2.out"
//     });
//   }

//   // Capture hash early
//   const hash = window.location.hash.replace("#", "");

//   // Remove hash to stop auto scroll default behavior
//   if (hash) {
//     history.replaceState(null, "", window.location.pathname);
//   }

//   // Default tab
//   let activeTarget = tabs[0].dataset.target;

//   // Hash override
//   if (hash && document.querySelector(`.tab[data-target="${hash}"]`)) {
//     activeTarget = hash;
//   }

//   activateTabByTarget(activeTarget);

//   // Manual scroll on page load if hash present
//   if (hash) {
//     setTimeout(scrollToTabs, 100);
//   }

//   // Hash change for menu clicks on same page
//   window.addEventListener("hashchange", () => {
//     const newHash = window.location.hash.replace("#", "");
//     if (newHash && document.querySelector(`.tab[data-target="${newHash}"]`)) {
//       activateTabByTarget(newHash);
//       setTimeout(scrollToTabs, 50);
//     }
//   });

//   // Tab clicks
//   tabs.forEach(tab => {
//     tab.addEventListener("click", () => {
//       const target = tab.dataset.target;
//       activateTabByTarget(target);
//       history.replaceState(null, "", `#${target}`);
//       scrollToTabs();
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tabs .tab");
  const panels = document.querySelectorAll(".tab-panel");
  const tabsWrapper = document.getElementById("partners-tabs-anchor");

  if (!tabs.length || !panels.length || !tabsWrapper) return;

  /* ===============================
     ACTIVATE TAB
  =============================== */
  function activateTabByTarget(target) {
    tabs.forEach(tab => tab.classList.remove("active"));
    panels.forEach(panel => panel.classList.remove("active"));

    const activeTab = document.querySelector(`.tab[data-target="${target}"]`);
    const activePanel = document.getElementById(target);

    if (activeTab && activePanel) {
      activeTab.classList.add("active");
      activePanel.classList.add("active");
    }

    return activePanel;
  }

  /* ===============================
     SCROLL TO TABS (STICKY HEADER SAFE)
  =============================== */
  function scrollToTabsSection() {
    const header = document.querySelector(".site-header");
    const offset = header ? header.offsetHeight : 0;

    const y =
      tabsWrapper.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }

  /* ===============================
     INITIAL LOAD (HASH SUPPORT)
  =============================== */
  const hash = window.location.hash.replace("#", "");
  let activeTarget = tabs[0].dataset.target;

  if (hash && document.querySelector(`.tab[data-target="${hash}"]`)) {
    activeTarget = hash;
  }

  activateTabByTarget(activeTarget);

  if (hash) {
    setTimeout(scrollToTabsSection, 150);
  }

  /* ===============================
     TAB CLICK (DESKTOP)
  =============================== */
  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.target;

      activateTabByTarget(target);
      history.pushState(null, "", `#${target}`);
      scrollToTabsSection();
    });
  });

  /* ===============================
     HASH CHANGE (MENU / BACK)
  =============================== */
  window.addEventListener("hashchange", () => {
    const newHash = window.location.hash.replace("#", "");
    if (document.querySelector(`.tab[data-target="${newHash}"]`)) {
      activateTabByTarget(newHash);
      setTimeout(scrollToTabsSection, 50);
    }
  });

  /* ===============================
     PARTNER CARD ANIMATION
  =============================== */
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    function animateCardsOnEnter(panel) {
      if (!panel) return;

      const container = panel.querySelector(".partner-cards");
      if (!container) return;

      const cards = container.querySelectorAll(".partner-card");
      if (!cards.length) return;

      // Kill old triggers for this container
      ScrollTrigger.getAll().forEach(st => {
        if (st.trigger === container) st.kill();
      });

      gsap.fromTo(
        cards,
        { opacity: 0, y: 70, scale: 0.96 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1.6,
          stagger: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: container,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    function animateActiveTab() {
      const activePanel = document.querySelector(".tab-panel.active");
      if (activePanel) animateCardsOnEnter(activePanel);
    }

    // Initial animation
    animateActiveTab();

    // Re-animate on tab switch or hash change
    window.addEventListener("hashchange", () =>
      setTimeout(animateActiveTab, 50)
    );

    tabs.forEach(tab =>
      tab.addEventListener("click", () =>
        setTimeout(animateActiveTab, 50)
      )
    );
  }
});


// Partner Card

document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  function animateCardsOnEnter(panel) {
    if (!panel) return;

    const container = panel.querySelector(".partner-cards");
    if (!container) return;

    const cards = container.querySelectorAll(".partner-card");
    if (!cards || !cards.length) return;

    // Kill previous animations on this container (important!)
    ScrollTrigger.getAll().forEach(st => {
      if (st.trigger === container) st.kill();
    });

    gsap.fromTo(
      cards,
      { opacity: 0, y: 70, scale: 0.96 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        ease: "power2.out",
        duration: 1.6,
        stagger: 0.3,
        scrollTrigger: {
          trigger: container,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      }
    );
  }

  function animateActiveTab() {
    const activePanel = document.querySelector(".tab-panel.active");
    if (activePanel) {
      animateCardsOnEnter(activePanel);
    }
  }

  // 1️⃣ Animate on initial page load
  animateActiveTab();

  // 2️⃣ Animate when hash changes (header/backend links)
  window.addEventListener("hashchange", () => {
    // Allow tab JS to apply `.active` first
    setTimeout(animateActiveTab, 50);
  });

  // 3️⃣ Animate when tabs are clicked
  document.querySelectorAll(".tabs .tab").forEach(tab => {
    tab.addEventListener("click", () => {
      setTimeout(animateActiveTab, 50);
    });
  });
});



// Industry page slider

document.addEventListener('DOMContentLoaded', () => {

  /* ================================
     PAGE DETECTION
  ================================= */
  const isPartnerPage = document.querySelector('.partner-tab');

  /* ================================
     INDUSTRY PAGE ELEMENTS (UNCHANGED)
  ================================= */
  const sections = document.querySelectorAll('.industry-panel');
  const tabs = document.querySelectorAll('.industry-tabs li');

  /* ================================
     MOBILE DROPDOWN (COMMON)
  ================================= */
  const dropdown = document.querySelector('.industry-dropdown');
  const dropdownToggle = dropdown?.querySelector('.dropdown-toggle');
  const dropdownLabel = dropdown?.querySelector('.active-label');
  const dropdownItems = dropdown?.querySelectorAll('.dropdown-list li');

  const START_OFFSET = 320;
  const MOBILE_SCROLL_OFFSET = -120;

  /* ================================
     MOBILE SCROLL (INDUSTRY ONLY)
  ================================= */
  function scrollToSectionMobile(id) {
    const section = document.getElementById(id);
    if (!section) return;

    const y =
      section.getBoundingClientRect().top +
      window.pageYOffset +
      MOBILE_SCROLL_OFFSET;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  /* ================================
   INITIAL MOBILE DROPDOWN LABEL
================================ */
  function setInitialDropdownLabel() {
    if (!dropdownLabel) return;

    const activeTab = document.querySelector('.industry-tabs li.active');
    let activeText = '';

    if (activeTab) {
      activeText = activeTab.textContent.trim();
    } else if (dropdownItems && dropdownItems.length) {
      activeText = dropdownItems[0].textContent.trim();
    }

    dropdownLabel.textContent = activeText;
    updateDropdownList(activeText);
  }

  window.addEventListener('load', setInitialDropdownLabel);

  function updateDropdownList(activeText) {
    if (!dropdownItems) return;

    dropdownItems.forEach(item => {
      const itemText = item.textContent.trim();
      item.style.display = itemText === activeText ? 'none' : '';
    });
  }

  /* ================================
     INDUSTRY SCROLL PROGRESS (UNCHANGED)
  ================================= */
  function updateProgress() {
    if (!sections.length || !tabs.length) return;

    let activeIndex = -1;
    let completedIndex = -1;

    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();

      if (
        rect.top <= window.innerHeight - START_OFFSET &&
        rect.bottom > START_OFFSET
      ) {
        activeIndex = index;
      }

      if (rect.bottom <= 0) {
        completedIndex = index;
      }
    });

    tabs.forEach(tab => {
      tab.classList.remove('active');
      const progress = tab.querySelector('.progress');
      if (progress) progress.style.width = '0%';
    });

    if (activeIndex !== -1) {
      const section = sections[activeIndex];
      const rect = section.getBoundingClientRect();
      const progress = tabs[activeIndex].querySelector('.progress');

      if (progress) {
        const total = rect.height;
        const scrolled = Math.min(
          total,
          Math.max(0, window.innerHeight - START_OFFSET - rect.top)
        );
        const percent = (scrolled / total) * 100;
        progress.style.width = percent + '%';
      }

      tabs[activeIndex].classList.add('active');
    }

    /* MOBILE LABEL UPDATE (INDUSTRY ONLY) */
    if (!isPartnerPage && window.innerWidth <= 768 && dropdownLabel) {
      const nextIndex = completedIndex + 1;
      if (tabs[nextIndex]) {
        const activeText = tabs[nextIndex].textContent.trim();
        dropdownLabel.textContent = activeText;
        updateDropdownList(activeText);
      }
    }
  }

  window.addEventListener('scroll', updateProgress);
  window.addEventListener('load', updateProgress);

  /* ================================
     DESKTOP TAB CLICK (INDUSTRY ONLY)
  ================================= */
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      document
        .getElementById(tab.dataset.target)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ================================
     MOBILE DROPDOWN TOGGLE (COMMON)
  ================================= */
  if (dropdown && dropdownToggle) {
    dropdownToggle.addEventListener('click', () => {
      dropdown.classList.toggle('open');
    });
  }

  /* ================================
     MOBILE DROPDOWN ITEM CLICK
     INDUSTRY vs PARTNER
  ================================= */
  dropdownItems?.forEach(item => {
    item.addEventListener('click', () => {
      const targetId = item.dataset.target;

      /* ---------- PARTNER PAGE ---------- */
      if (isPartnerPage) {
        const partnerTabs = document.querySelectorAll('.tabs .tab');
        const partnerPanels = document.querySelectorAll('.tab-panel');

        partnerTabs.forEach(tab => {
          tab.classList.toggle('active', tab.dataset.target === targetId);
        });

        partnerPanels.forEach(panel => {
          panel.classList.toggle('active', panel.id === targetId);
        });

        if (dropdownLabel) {
           const activeText = item.textContent.trim();
           dropdownLabel.textContent = activeText;
           updateDropdownList(activeText);
        }

        dropdown.classList.remove('open');
        return;
      }

      /* ---------- INDUSTRY PAGE (UNCHANGED) ---------- */
      scrollToSectionMobile(targetId);

      if (dropdownLabel) {
         const activeText = item.textContent.trim();
         dropdownLabel.textContent = activeText;
         updateDropdownList(activeText);
      }

      dropdown.classList.remove('open');
    });
  });

});



// sia animation
document.addEventListener("DOMContentLoaded", function () {

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  /* =========================
     DESKTOP ANIMATION (UNCHANGED)
  ========================= */
  if (!isMobile) {
    const image = document.querySelector(".desktop-only.animate-image");
    const leftGroup = document.querySelector(".animate-left");
    const rightGroup = document.querySelector(".animate-right");

    if (!image || !leftGroup || !rightGroup) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        // STEP 1: Image
        image.classList.add("animate-in");

        // STEP 2: Left & Right
        setTimeout(() => {
          leftGroup.classList.add("animate-in");
          rightGroup.classList.add("animate-in");
        }, 500);

        obs.unobserve(entry.target);
      });
    }, { threshold: 0.35 });

    observer.observe(image);
  }

  /* =========================
     MOBILE ANIMATION (FIXED)
  ========================= */
  if (isMobile) {
    const mobileImage = document.querySelector(".mobile-only canvas");
    const points = document.querySelectorAll(".point-item");

    if (!points.length) return;

    // Reset states
    mobileImage.classList.remove("animate-in");
    points.forEach(p => p.classList.remove("animate-in"));

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        // STEP 1: Image first
        mobileImage.classList.add("animate-in");

        // STEP 2: Points stagger
        points.forEach((point, index) => {
          setTimeout(() => {
            point.classList.add("animate-in");
          }, 400 + index * 220);
        });

        obs.unobserve(entry.target);
      });
    }, {
      threshold: 0.1,
      rootMargin: "0px 0px -15% 0px"
    });

    // 👇 Observe image directly so animation always triggers
    observer.observe(mobileImage);
  }

});


  // ---------------- Our Service Banner Animation ----------------------//
document.addEventListener("DOMContentLoaded", function () {
  const industryBanner = document.querySelector(".industry-banner-image");
  if (industryBanner) {
    gsap.to(".slide-in-image", {
      x: 0,
      opacity: 1,
      duration: 1.2,
      ease: "power2.out",
      stagger: 0.3,
      scrollTrigger: {
        trigger: ".industry-banner",
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });
  }
});

// ID Links
// document.addEventListener("DOMContentLoaded", function () {
//   // Smooth scroll for links on the same page
//   const links = document.querySelectorAll('a[href^="#"]');
//   links.forEach(link => {
//     link.addEventListener("click", function (e) {
//       e.preventDefault();
//       const targetId = this.getAttribute("href").substring(1);
//       const targetElement = document.getElementById(targetId);
//       if (!targetElement) return;

//       const headerOffset = 80; // adjust if you have sticky header
//       const elementPosition = targetElement.getBoundingClientRect().top;
//       const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth"
//       });
//     });
//   });

//   // Smooth scroll for page load with hash (cross-page)
//   if (window.location.hash) {
//     const targetElement = document.getElementById(window.location.hash.substring(1));
//     if (targetElement) {
//       setTimeout(() => { // give the page some time to render
//         const headerOffset = 0; // same offset as above
//         const elementPosition = targetElement.getBoundingClientRect().top;
//         const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

//         window.scrollTo({
//           top: offsetPosition,
//           behavior: "smooth"
//         });
//       }, 100); // adjust timeout if needed
//     }
//   }
// });


document.addEventListener("DOMContentLoaded", () => {

  const scrollToTarget = (target, hash) => {
    if (!target) return;

    // wait for GSAP + layout settle
    setTimeout(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

      if (hash) {
        history.pushState(null, "", `#${hash}`);
      }
    }, 150);
  };

  /* ===============================
     SAME PAGE LINKS
  =============================== */
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute("href");

    if (href === "#" || link.classList.contains("tab")) return;

    const id = href.slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    scrollToTarget(target, id);
  });

  /* ===============================
     PAGE LOAD WITH HASH
  =============================== */
  if (window.location.hash) {
    const id = window.location.hash.slice(1);

    const waitForTarget = setInterval(() => {
      const target = document.getElementById(id);
      if (!target) return;

      clearInterval(waitForTarget);
      scrollToTarget(target, id);
    }, 100);

    setTimeout(() => clearInterval(waitForTarget), 3000);
  }
});

// Mobile Industry Page Dropdown
// document.addEventListener("DOMContentLoaded", () => {
//   const dropdown = document.querySelector(".industry-mobile-dropdown");
//   if (!dropdown) return;

//   const toggleBtn = dropdown.querySelector(".industry-mobile-toggle");
//   const list = dropdown.querySelector(".industry-mobile-list");
//   const label = dropdown.querySelector(".industry-mobile-label");

//   const panels = document.querySelectorAll(".industry-panel");
//   const desktopTabs = document.querySelectorAll(".industry-tabs li");

//   /* ===============================
//      TOGGLE DROPDOWN
//   =============================== */
//   toggleBtn.addEventListener("click", () => {
//     dropdown.classList.toggle("is-open");
//   });

//   /* ===============================
//      ITEM CLICK
//   =============================== */
//   list.querySelectorAll("li").forEach(item => {
//     item.addEventListener("click", () => {
//       const target = item.dataset.target;

//       // Update label
//       label.textContent = item.textContent;

//       // Close dropdown
//       dropdown.classList.remove("is-open");

//       // Switch panels
//       panels.forEach(panel => panel.classList.remove("active"));

//       const activePanel = document.getElementById(target);
//       if (activePanel) {
//         activePanel.classList.add("active");

//         activePanel.scrollIntoView({
//           behavior: "smooth",
//           block: "start"
//         });
//       }

//       // Sync desktop tabs (optional)
//       desktopTabs.forEach(tab => {
//         tab.classList.toggle("active", tab.dataset.target === target);
//       });
//     });
//   });

//   /* ===============================
//      CLOSE ON OUTSIDE CLICK
//   =============================== */
//   document.addEventListener("click", e => {
//     if (!dropdown.contains(e.target)) {
//       dropdown.classList.remove("is-open");
//     }
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const dropdown = document.querySelector(".industry-mobile-dropdown");
//   if (!dropdown) return;

//   const toggleBtn = dropdown.querySelector(".industry-mobile-toggle");
//   const list = document.querySelector(".industry-mobile-list");
//   const label = dropdown.querySelector(".industry-mobile-label");

//   const panels = document.querySelectorAll(".industry-panel");
//   const desktopTabs = document.querySelectorAll(".industry-tabs li");

//   let isClickScrolling = false; // prevents scroll overwrite after click

//   /* ===============================
//      TOGGLE DROPDOWN
//   =============================== */
// toggleBtn.addEventListener("click", () => {
//   dropdown.classList.toggle("is-open");
//   if (list) {
//       list.classList.toggle("tab-is-open");
//     }
   
// });

//   /* ===============================
//      ITEM CLICK
//   =============================== */
//   list.querySelectorAll("li").forEach(item => {
//     item.addEventListener("click", () => {
//       const target = item.dataset.target;

//       // Update label immediately
//       label.textContent = item.textContent;

//       dropdown.classList.remove("is-open");
//       isClickScrolling = true;

//       panels.forEach(panel => panel.classList.remove("active"));

//       const activePanel = document.getElementById(target);
//       if (activePanel) {
//         activePanel.classList.add("active");

//         activePanel.scrollIntoView({
//           behavior: "smooth",
//           block: "start"
//         });
//       }

//       // Sync desktop tabs
//       desktopTabs.forEach(tab => {
//         tab.classList.toggle("active", tab.dataset.target === target);
//       });

//       // Allow scroll-sync again after scroll settles
//       setTimeout(() => {
//         isClickScrolling = false;
//       }, 600);
//     });
//   });

//   /* ===============================
//      SCROLL → UPDATE LABEL EARLY
//   =============================== */
//   function updateLabelOnScroll() {
//     if (isClickScrolling) return;

//     let activePanel = null;
//     let closestDistance = Infinity;

//     panels.forEach(panel => {
//       const rect = panel.getBoundingClientRect();

//       // Only consider panels partially visible
//       if (rect.bottom > 0 && rect.top < window.innerHeight) {
//         // Distance from top of viewport to panel top (10% from top)
//         const distance = Math.abs(rect.top - window.innerHeight * 0.1);

//         if (distance < closestDistance) {
//           closestDistance = distance;
//           activePanel = panel;
//         }
//       }
//     });

//     if (!activePanel) return;

//     const activeTab = document.querySelector(
//       `.industry-tabs li[data-target="${activePanel.id}"]`
//     );

//     if (activeTab) {
//       const newText = activeTab.textContent.trim();
//       if (label.textContent !== newText) {
//         label.textContent = newText;
//       }
//     }
//   }

//   window.addEventListener("scroll", updateLabelOnScroll);
//   updateLabelOnScroll(); // initial sync

//   /* ===============================
//      CLOSE ON OUTSIDE CLICK
//   =============================== */
//   document.addEventListener("click", e => {
//     if (!dropdown.contains(e.target)) {
//       dropdown.classList.remove("is-open");
//     }
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const dropdown = document.querySelector(".industry-mobile-dropdown");
//   if (!dropdown) return;

//   const toggleBtn = dropdown.querySelector(".industry-mobile-toggle");
//   const list = dropdown.querySelector(".industry-mobile-list");
//   const label = dropdown.querySelector(".industry-mobile-label");
//   const closeBtn = list.querySelector("span"); // the span wrapping the SVG

//   const panels = document.querySelectorAll(".industry-panel");
//   const desktopTabs = document.querySelectorAll(".industry-tabs li");

//   let isClickScrolling = false; // prevents scroll overwrite after click

//   /* ===============================
//      TOGGLE DROPDOWN
//   =============================== */
//   toggleBtn.addEventListener("click", () => {
//     const isOpen = dropdown.classList.toggle("is-open");
//     if (list) list.classList.toggle("tab-is-open");

//     // Add/remove 'close-btn' class when dropdown opens/closes
//     if (closeBtn) {
//       closeBtn.classList.toggle("close-btn", isOpen);
//     }
//   });

//   // Initially remove class
//   if (closeBtn) closeBtn.classList.remove("close-btn");

//   /* ===============================
//      CLICK ON CROSS TO CLOSE
//   =============================== */
//   if (closeBtn) {
//     closeBtn.addEventListener("click", () => {
//       dropdown.classList.remove("is-open");
//       if (list) list.classList.remove("tab-is-open");
//       closeBtn.classList.remove("close-btn");
//     });
//   }

//   /* ===============================
//      ITEM CLICK
//   =============================== */
//   list.querySelectorAll("li").forEach(item => {
//     item.addEventListener("click", () => {
//       const target = item.dataset.target;

//       label.textContent = item.textContent;

//       dropdown.classList.remove("is-open");
//       if (closeBtn) closeBtn.classList.remove("close-btn");
//       isClickScrolling = true;

//       panels.forEach(panel => panel.classList.remove("active"));

//       const activePanel = document.getElementById(target);
//       if (activePanel) {
//         activePanel.classList.add("active");

//         activePanel.scrollIntoView({
//           behavior: "smooth",
//           block: "start"
//         });
//       }

//       desktopTabs.forEach(tab => {
//         tab.classList.toggle("active", tab.dataset.target === target);
//       });

//       setTimeout(() => {
//         isClickScrolling = false;
//       }, 600);
//     });
//   });

//   /* ===============================
//      SCROLL → UPDATE LABEL EARLY
//   =============================== */
//   function updateLabelOnScroll() {
//     if (isClickScrolling) return;

//     let activePanel = null;
//     let closestDistance = Infinity;

//     panels.forEach(panel => {
//       const rect = panel.getBoundingClientRect();
//       if (rect.bottom > 0 && rect.top < window.innerHeight) {
//         const distance = Math.abs(rect.top - window.innerHeight * 0.1);
//         if (distance < closestDistance) {
//           closestDistance = distance;
//           activePanel = panel;
//         }
//       }
//     });

//     if (!activePanel) return;

//     const activeTab = document.querySelector(
//       `.industry-tabs li[data-target="${activePanel.id}"]`
//     );

//     if (activeTab) {
//       const newText = activeTab.textContent.trim();
//       if (label.textContent !== newText) label.textContent = newText;
//     }
//   }

//   window.addEventListener("scroll", updateLabelOnScroll);
//   updateLabelOnScroll();

//   /* ===============================
//      CLOSE ON OUTSIDE CLICK
//   =============================== */
//   document.addEventListener("click", e => {
//     if (!dropdown.contains(e.target)) {
//       dropdown.classList.remove("is-open");
//       if (list) list.classList.remove("tab-is-open");
//       if (closeBtn) closeBtn.classList.remove("close-btn");
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  const dropdown = document.querySelector(".industry-mobile-dropdown");
  if (!dropdown) return;

  const toggleBtn = dropdown.querySelector(".industry-mobile-toggle");
  const list = dropdown.querySelector(".industry-mobile-list");
  const label = dropdown.querySelector(".industry-mobile-label");
  const closeBtn = list.querySelector("span"); // the span wrapping the SVG

  const panels = document.querySelectorAll(".industry-panel");
  const desktopTabs = document.querySelectorAll(".industry-tabs li");

  let isClickScrolling = false; // prevents scroll overwrite after click

  /* ===============================
     TOGGLE DROPDOWN
  =============================== */
  toggleBtn.addEventListener("click", () => {
    const isOpen = dropdown.classList.toggle("is-open");
    if (list) list.classList.toggle("tab-is-open");

    if (closeBtn) {
      if (isOpen) {
        closeBtn.style.display = "flex";
        closeBtn.style.alignItems = "center";
        closeBtn.style.justifyContent = "center";
      } else {
        closeBtn.style.display = "none";
      }
    }
  });

  // Initially hide the cross
  if (closeBtn) {
    closeBtn.style.display = "none";
  }

  /* ===============================
     CLICK ON CROSS TO CLOSE
  =============================== */
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      dropdown.classList.remove("is-open");
      if (list) list.classList.remove("tab-is-open");
      closeBtn.style.display = "none";
    });
  }

  /* ===============================
     ITEM CLICK
  =============================== */
  list.querySelectorAll("li").forEach(item => {
    item.addEventListener("click", () => {
      const target = item.dataset.target;

      label.textContent = item.textContent;

      dropdown.classList.remove("is-open");
      if (closeBtn) closeBtn.style.display = "none";
      isClickScrolling = true;

      panels.forEach(panel => panel.classList.remove("active"));

      const activePanel = document.getElementById(target);
      if (activePanel) {
        activePanel.classList.add("active");

        activePanel.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

      desktopTabs.forEach(tab => {
        tab.classList.toggle("active", tab.dataset.target === target);
      });

      setTimeout(() => {
        isClickScrolling = false;
      }, 600);
    });
  });

  /* ===============================
     SCROLL → UPDATE LABEL EARLY
  =============================== */
  function updateLabelOnScroll() {
    if (isClickScrolling) return;

    let activePanel = null;
    let closestDistance = Infinity;

    panels.forEach(panel => {
      const rect = panel.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const distance = Math.abs(rect.top - window.innerHeight * 0.1);
        if (distance < closestDistance) {
          closestDistance = distance;
          activePanel = panel;
        }
      }
    });

    if (!activePanel) return;

    const activeTab = document.querySelector(
      `.industry-tabs li[data-target="${activePanel.id}"]`
    );

    if (activeTab) {
      const newText = activeTab.textContent.trim();
      if (label.textContent !== newText) label.textContent = newText;
    }
  }

  window.addEventListener("scroll", updateLabelOnScroll);
  updateLabelOnScroll();

  /* ===============================
     CLOSE ON OUTSIDE CLICK
  =============================== */
  document.addEventListener("click", e => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove("is-open");
      if (list) list.classList.remove("tab-is-open");
      if (closeBtn) closeBtn.style.display = "none";
    }
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const dropdownButton = document.querySelector('.industry-mobile-dropdown ');
  const industrySection = document.querySelector('.industry-section');

  if (!dropdownButton || !industrySection) return;

  // Start hidden
  dropdownButton.style.opacity = 0;
  dropdownButton.style.transition = "opacity 0.3s ease";

  function updateButtonOpacity() {
    const rect = industrySection.getBoundingClientRect();

    // Show button when top enters viewport
    const show = rect.top < window.innerHeight * 0.95 && rect.bottom > 0;

    // Hide button when bottom reaches bottom of viewport
    const hide = rect.bottom <= window.innerHeight;

    dropdownButton.style.opacity = hide ? 0 : show ? 1 : 0;
  }

  // Initial check
  updateButtonOpacity();

  window.addEventListener('scroll', updateButtonOpacity);
  window.addEventListener('resize', updateButtonOpacity);
});

